<template>
  <div class="mal-sale-body">
      <card-body></card-body>
      <store-body></store-body>
      <category-goods-show></category-goods-show>
  </div>
</template>

<script>
    import CategoryGoodsShow  from './CategoryGoodsShow.vue'
    import CardBody from './CardBody.vue'
    import StoreBody from './StoreBody.vue'
    export default {
       components : {
           'card-body' : CardBody,
           'store-body' : StoreBody,
           'category-goods-show' :CategoryGoodsShow
       }
    }
</script>

<style scoped lang="scss">
  .mal-sale-body{
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    margin-top: 10px;
    align-items: flex-start;
  }
</style>
